/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import './RMDTableMobile.scss';

import React from 'react';
import { useSelector } from 'react-redux';

import { currency } from '../../../utils/dashboard-utils';
import TableHeaderMobile from './TableHeaderMobile';
import PlanMobile from './PlanMobile';
import AgreementTypeMobile from './AgreementTypeMobile';
import AgreementMobile from './AgreementMobile';
import { getRMDSummary } from '../../../redux/modules/RMD/RMDSetting.selectors';

const RMDTableMobile = () => {
  const rmdSummary = useSelector(getRMDSummary);
  const showYTDColumns = rmdSummary.displayDistributionColumns;
  const pagination = rmdSummary.pagination || {};
  const currentRmdYear = rmdSummary.rmdYear;
  const totalBalance = currency(rmdSummary.totalBalance);
  const totalRMD = currency(rmdSummary.totalRMD);
  const retirementPlans = rmdSummary.retirementPlans || [];

  function showMore(e) {
    e.target.parentElement.parentElement.parentElement.parentElement.classList.remove(
      'minimized'
    );
  }

  return (
    <div id="RMD-Table-Mobile">
      <table className="RMD-Table-Mobile minimized">
        <TableHeaderMobile
          showYTDColumns={showYTDColumns || null}
          currentRmdYear={currentRmdYear || null}
          totalBalance={totalBalance || null}
          totalRMD={totalRMD || null}
          rmdSummary={rmdSummary || null}
        />

        {retirementPlans.map((plan, index) => [
          <PlanMobile
            showYTDColumns={showYTDColumns || null}
            plan={plan || null}
          />,
          _tableBodyAccordion(
            plan.agreementTypeContainers,
            currentRmdYear,
            plan.planName,
            showYTDColumns
          ),
        ])}
        {pagination.isCollapsed ? (
          <tbody className="expandText">
            <tr>
              <td>
                <button
                  className="showMore view_more_rows_btn"
                  onClick={(e) => showMore(e)}
                >
                  View complete RMD Summary breakdown.{' '}
                  {pagination.remainingLength} more rows available.
                </button>
              </td>
            </tr>
          </tbody>
        ) : null}
      </table>
    </div>
  );
};

const _accordionBody = (
  agreement,
  currentRmdYear,
  planName,
  showYTDColumns
) => {
  return [
    <AgreementMobile
      agreement={agreement}
      currentRmdYear={currentRmdYear}
      planName={planName}
      showYTDColumns={showYTDColumns}
    />,
  ];
};

const _tableBodyAccordion = (
  agreementTypes,
  currentRmdYear,
  planName,
  showYTDColumns
) => {
  return agreementTypes.map((agreementType) => {
    return [
      <AgreementTypeMobile
        agreementType={agreementType}
        currentRmdYear={currentRmdYear}
        planName={planName}
        showYTDColumns={showYTDColumns}
      />,
      agreementType.rmdAgreements.map((agreement) => {
        return _accordionBody(
          agreement,
          currentRmdYear,
          planName,
          showYTDColumns
        );
      }),
    ];
  });
};

export default RMDTableMobile;
